<template>
  <div>
    <v-menu offset-y :close-on-content-click="false" min-width="400" max-width="400" v-model="menu"
      v-if="IS_SIGNED_INTO_CABLE || IS_SIGNED_INTO_MPX">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon large>account_circle</v-icon>
        </v-btn>
      </template>
      <v-card flat>
        <v-card-text v-if="IS_SIGNED_INTO_CABLE">
          <v-list two-line subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Signed in as</v-list-tile-title>
                <v-list-tile-sub-title>{{ cableUserInfo.comcast_email }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                  <v-btn  @click="signOutOfCable(true)" ripple color="secondary">
                    Sign Out
                  </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-text v-else class="text-xs-center">
          <v-btn @click="signInToCable()" color="primary" ripple>
            Sign In
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- <v-card class="vop-bg-whisper">
        <v-card-text class="pa-0"> -->
      <!-- <v-tabs color="vop-bg-whisper" v-model="activeTab" centered slider-color="primary" ref="tabs" icons-and-text>
            <v-tab class="text-lowercase">
              mpx
              <v-icon :color="IS_SIGNED_INTO_MPX ? 'success' : ''">check_circle</v-icon>
            </v-tab>
            <v-tab>
              CABLE
              <v-icon :color="IS_SIGNED_INTO_CABLE ? 'success' : ''">check_circle</v-icon>
            </v-tab>
          </v-tabs> -->
      <!-- <v-tabs-items v-model="activeTab"> -->
      <!-- MPX -->
      <!-- <v-tab-item>
              <v-card flat>
                <v-card-text v-if="IS_SIGNED_INTO_MPX">
                  <v-list subheader two-line>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Signed in as</v-list-tile-title>
                        <v-list-tile-sub-title>{{ mpxUserInfo.userName }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-tooltip left>
                          <v-btn icon @click="signOutOfMPX(true)" ripple slot="activator">
                            <v-icon color="primary">exit_to_app</v-icon>
                          </v-btn>
                          <span>Sign Out of mpx</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-subheader v-if="!$lodash.isEmpty(mpxParentAccount)">mpx ACCOUNT</v-subheader>
                    <v-list-tile avatar v-if="!$lodash.isEmpty(mpxParentAccount)">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ mpxParentAccount.title }}</v-list-tile-title>
                        <v-list-tile-sub-title class="show-overflow">
                          {{ mpxParentAccount.id }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-tooltip left>
                          <v-btn icon @click="switchMPXAccount()" ripple slot="activator">
                            <v-icon color="primary">swap_horiz</v-icon>
                          </v-btn>
                          <span>Switch Account</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-list-tile avatar v-if="!$lodash.isEmpty(mpxParentAccount)">
                      <v-list-tile-content>
                        <v-list-tile-title class="grey--text text--darken-2">Permissions</v-list-tile-title>
                        <v-list-tile-sub-title class="show-overflow">
                          {{ accessText(mpxParentAccount._service) }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
                <v-card-text v-else class="text-xs-center">
                  <v-btn @click="signInToMPX()" color="primary" ripple>
                    Sign In
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item> -->
      <!-- Cable -->
      <!-- <v-tab-item>
              <v-card flat>
                <v-card-text v-if="IS_SIGNED_INTO_CABLE">
                  <v-list two-line subheader>
                    <v-list-tile avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>Signed in as</v-list-tile-title>
                        <v-list-tile-sub-title>{{ cableUserInfo.comcast_email }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-tooltip left>
                          <v-btn icon @click="signOutOfCable(true)" ripple slot="activator">
                            <v-icon color="primary">exit_to_app</v-icon>
                          </v-btn>
                          <span>Sign out of CABLE</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
                <v-card-text v-else class="text-xs-center">
                  <v-btn @click="signInToCable()" color="primary" ripple>
                    Sign In
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item> -->
      <!-- </v-tabs-items> -->
      <!-- </v-card-text>
        <v-card-actions class="pt-2">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="signOutAll()">Sign Out All</v-btn>
        </v-card-actions>
      </v-card> -->
    </v-menu>
    <template v-else>
      <v-btn flat @click="signInToCable">
        Sign In
      </v-btn>
    </template>
    <!-- <v-menu offset-y v-else>
      <template v-slot:activator="{ on }">
        <v-btn flat v-on="on">
          Sign In
        </v-btn>
      </template>
      <v-list class="secondary white--text">
        <v-list-tile @click="signInToCable">
          <v-list-tile-title>CABLE (sso)</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="signInToMPX">
          <v-list-tile-title>mpx</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu> -->
  </div>

</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"
import AppService from "@/AppService"
import AuthService from "@/Auth/AuthService"
import * as appDataService from "@/AppDataService"
import * as authDataService from "@/Auth/AuthDataService"
import {
  SET_MPX_USER_INFO,
  SET_CABLE_USER_INFO,
  SET_MVATS_AUTHORIZE_INFO,
  SET_OPSUI_AUTHORIZE_INFO,
  SET_MPX_PARENT_ACCOUNT,
  SET_SERVICE_REGISTRY,
  SET_MPX_SUB_ACCOUNTS
} from "@/store/constants/mutation-types"
import { IS_SIGNED_INTO_CABLE, IS_SIGNED_INTO_MPX } from "@/store/constants/getter-types"

export default {
  name: "VOPAccount",
  data() {
    return {
      activeTab: null,
      menu: false
    }
  },
  watch: {
    menu: function (newValue) {
      if (newValue) {
        if (this.$lodash.isNull(this.activeTab)) {
          this.updateTabSelection()
        }
        this.setSliderBarStyle()
      }
    }
  },
  computed: {
    ...mapState([
      "mpxParentAccount",
      "mpxUserInfo",
      "cableUserInfo"
    ]),
    ...mapGetters([
      IS_SIGNED_INTO_CABLE,
      IS_SIGNED_INTO_MPX
    ])
  },
  methods: {
    ...mapMutations([
      SET_MPX_USER_INFO,
      SET_CABLE_USER_INFO,
      SET_MVATS_AUTHORIZE_INFO,
      SET_OPSUI_AUTHORIZE_INFO,
      SET_MPX_PARENT_ACCOUNT,
      SET_SERVICE_REGISTRY,
      SET_MPX_SUB_ACCOUNTS
    ]),
    /**
     * signOutAll - Signout of MPX and Cable Accounts
     */
    signOutAll() {
      this.menu = false
      if (this.IS_SIGNED_INTO_CABLE && this.IS_SIGNED_INTO_MPX) {
        this.signOutOfCable(false)
          .then(() => {
            return this.signOutOfMPX(false)
          }).then(() => {
            document.location.href = "/"
          })
      } else if (this.IS_SIGNED_INTO_CABLE) {
        this.signOutOfCable(true)
      } else if (this.IS_SIGNED_INTO_MPX) {
        this.signOutOfMPX(true)
      }
    },

    /**
     * signOutOfMPX - Signout of MPX
     * @param {boolean} redirect
     * @return {Promise}  description
     */
    signOutOfMPX(redirect) {
      return authDataService
        .mpxSignOut()
        .then(() => {
          //  Ensure user data is cleared before publishing event
          appDataService.setMPXUserInfo({})
            .then(() => {
              this.SET_MPX_USER_INFO({}) // Update store
              return appDataService.setMVATSAuthorizeInfo({})
            })
            .then(() => {
              this.SET_MVATS_AUTHORIZE_INFO({}) // Update store
              return appDataService.setOpsUIAuthorizeInfo({})
            })
            .then(() => {
              this.SET_OPSUI_AUTHORIZE_INFO({}) // Update store
              return appDataService.setServiceRegistry({})
            })
            .then(() => {
              this.SET_SERVICE_REGISTRY({}) // Update store
              return appDataService.setMPXSubAccounts({})
            })
            .then(() => {
              this.SET_MPX_SUB_ACCOUNTS({}) // Update store
              return appDataService.setMPXParentAccountInfo({})
            })
            .then(() => {
              this.SET_MPX_PARENT_ACCOUNT({}) // Update store
              if (redirect) {
                document.location.reload()
              }
            })
        })
        .catch(() => {
          //  TODO: How can we handle this scenario better ?
          AppService.$emit("event:mpxSignOutFailure")
        })
    },

    /**
     * Show mpx login
     */
    signInToMPX() {
      this.menu = false
      this.$router.push("/mpx-login")
    },

    /**
     * switchMPXAccount
     */
    switchMPXAccount() {
      this.menu = false
      let redirectTo = this.$route.path
      this.$router.push({
        name: "MPXAccountSelection",
        query: {
          redirect: redirectTo
        }
      })
    },

    /**
     * signOutCable - Clear cached user data and redirect to home
     * @param {boolean} redirect
     * @returns {Promise}
     */
    signOutOfCable(redirect) {
      return appDataService
        .setCableUserInfo({})
        .then(() => {
          this.SET_CABLE_USER_INFO({}) // Update store
          AppService.$emit("event:cableSignOutSuccess")
          if (redirect) {
            document.location.href = "/"
          }
        })
    },

    /**
     * signInToCable - Redirect the user to begin logging in through SSO
     */
    signInToCable() {
      //  Redirect to Websec pingfederate authorization endpoint
      authDataService.getWebSecUrl()
        .then((webSecEndPoint) => {
          window.location.href = webSecEndPoint
        })
    },

    /**
     * accessText
     * @param {array} services
     */
    accessText(services) {
      return AuthService.accessText(services)
    },

    /**
     * updateTabSelection
     */
    updateTabSelection() {
      let mpxPaths = [
        "/metadata-rules",
        "/pre-ingest",
        "/providers/provider-list",
        "/providers/provider-groups"
      ]
      let opsUIPaths = [
        "/xml-backlog",
        "/asset-status"
      ]
      let curentPath = this.$route.path

      let isMPXPath = this.$lodash.findIndex(mpxPaths, (path) => {
        return path.indexOf(curentPath) > -1
      }) > -1
      let isOpsUIPath = this.$lodash.findIndex(opsUIPaths, (path) => {
        return path.indexOf(curentPath) > -1
      }) > -1

      if (isMPXPath) {
        this.activeTab = 0
      } else if (isOpsUIPath) {
        this.activeTab = 1
      } else {
        this.activeTab = 1
      }
    },
    /**
     * setSliderBarStyle
     */
    setSliderBarStyle() {
      // NOTE: This is a fix for Vuetify bug https://github.com/vuetifyjs/vuetify/issues/1978
      // Need to comeback and see if this is fixed in latest version
      let wrapperElArray = []
      let wrapperEl = null
      if (this.$refs.tabs) {
        wrapperElArray = this.$refs.tabs.$el.getElementsByClassName("v-tabs__slider-wrapper")
        if (wrapperElArray.length > 0) {
          wrapperEl = wrapperElArray[0]
          if (this.$lodash.isNull(this.activeTab)) {
            wrapperEl.setAttribute("style", "left:0px; width: 0px;")
          } else if (this.activeTab === 0) {
            wrapperEl.setAttribute("style", "left:40px; width: 160px;")
          } else if (this.activeTab === 1) {
            wrapperEl.setAttribute("style", "left:200px; width: 160px;")
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.show-overflow {
  white-space: normal;
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/Auth/UserFlyout.vue